import React, { useEffect } from "react";
import { useCrud } from "../common/crudCard/useCrud";
import { CrudLayout } from "../common/crudCard/crudLayout";
import { useHistory } from "react-router-dom";
import { getPersonas, checkDeletePersona, deletePersona } from "../../services/personasService";
import { cleanString } from "../utils/cleanString";
import PersonasTable from "./personasTable";

export default function Personas(props) {
  const { onLoading, onDoneLoading } = props;

  const title = "Personas";

  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Personas",
    },
  ];

  const history = useHistory();

  const filterData = (records, query) => {
    return records.filter(
      (m) =>
        cleanString(m.nombre).includes(cleanString(query)) ||
        cleanString(m.apellido).includes(cleanString(query)) ||
        cleanString(m.email).includes(cleanString(query)) ||
        cleanString(m.dni).includes(cleanString(query)) ||
        cleanString(m.cuit).includes(cleanString(query)),
    );
  };

  const checkBeforeDelete = async (id) => {
    const canDelete = await checkDeletePersona(id);
    return canDelete;
  };

  const onDelete = async (id) => {
    try {
      await deletePersona(id);
    } catch (ex) {
      throw ex;
    }
  };

  const crud = useCrud({
    defaultPath: "/personas",
    defaultSortColumn: { path: "apellido", order: "asc" },
    checkBeforeDelete,
    filterData,
    onDelete,
    onLoading,
    onDoneLoading,
  });

  const fetchData = async () => {
    onLoading();
    const registros = await getPersonas();
    onDoneLoading();
    if (registros === "NETWORK ERROR") return history.push("/noconnection");
    crud.updateAllRecords(registros);
  };

  const handleSearch = (query) => {
    crud.setSearchQuery(query);
    crud.setCurrentPage(1);
  };

  useEffect(() => {
    if (!crud.mounted) {
      fetchData();
      crud.setMounted(true);
    }
  }, []);

  return (
    <CrudLayout
      title={title}
      breadcrumbs={breadcrumbs}
      newLink="/personas/nueva"
      permisos={crud.permisos}
      onChangeSearch={handleSearch}
      onPageChange={crud.handlePageChange}
      filterData={filterData}
      totalCount={crud.totalCount}
      pageSize={crud.pageSize}
      currentPage={crud.currentPage}
    >
      <PersonasTable
        permisos={crud.permisos}
        records={crud.records}
        onDelete={(id) => crud.handleDelete(id)}
        onEdit={(id) => crud.handleEdit(id)}
        onSort={(sortColumn) => crud.handleSort(sortColumn)}
        onView={(id) => crud.handleView(id)}
        sortColumn={crud.sortColumn}
      />
    </CrudLayout>
  );
}
